import { Media } from './Media';
import { ImageMeta } from './MediaMeta';
import { FragmentMeta } from '../content/model/FragmentMeta';
import { ImageUrlBuilder } from './ImageUrlBuilder';
/**
 * Class representing an Image resource with helper functions.
 * Image URL helper functions will take into consideration staging and custom hostname overrides.
 */
export class Image extends Media {
    /**
     * Creates a new Image instance.
     * @param data JSON data from delivery API
     * @param config Client configuration
     */
    constructor(data, config) {
        super(data, config);
        if (data && data._meta) {
            this._meta = new ImageMeta(data._meta);
        }
    }
    /**
     * Returns a builder which can be used to construct a URL to this image resource.
     * You can apply transformations such as resize and image format using the returned builder.
     *
     * ```typescript
     * image.thumbnail().width(500).build();
     * ```
     */
    url() {
        return new ImageUrlBuilder(this);
    }
    /**
     * Export Image to JSON
     */
    toJSON() {
        const result = super.toJSON();
        if (this._meta) {
            result._meta = this._meta.toJSON();
        }
        return result;
    }
    /**
     * @hidden
     * Returns true if the provided fragment is an image
     * @param fragment
     */
    static isImage(fragment) {
        return (FragmentMeta.isFragment(fragment) &&
            fragment._meta.schema ===
                'http://bigcontent.io/cms/schema/v1/core#/definitions/image-link');
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW1hZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL21lZGlhL0ltYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFDaEMsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGFBQWEsQ0FBQztBQUN4QyxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sK0JBQStCLENBQUM7QUFDN0QsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBR3BEOzs7R0FHRztBQUNILE1BQU0sT0FBTyxLQUFNLFNBQVEsS0FBSztJQUM5Qjs7OztPQUlHO0lBQ0gsWUFBWSxJQUFTLEVBQUUsTUFBMkI7UUFDaEQsS0FBSyxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQztRQUNwQixJQUFJLElBQUksSUFBSSxJQUFJLENBQUMsS0FBSyxFQUFFO1lBQ3RCLElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBSSxTQUFTLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1NBQ3hDO0lBQ0gsQ0FBQztJQUVEOzs7Ozs7O09BT0c7SUFDSCxHQUFHO1FBQ0QsT0FBTyxJQUFJLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNuQyxDQUFDO0lBRUQ7O09BRUc7SUFDSCxNQUFNO1FBQ0osTUFBTSxNQUFNLEdBQUcsS0FBSyxDQUFDLE1BQU0sRUFBRSxDQUFDO1FBQzlCLElBQUksSUFBSSxDQUFDLEtBQUssRUFBRTtZQUNkLE1BQU0sQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQztTQUNwQztRQUNELE9BQU8sTUFBTSxDQUFDO0lBQ2hCLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksTUFBTSxDQUFDLE9BQU8sQ0FBQyxRQUFhO1FBQ2pDLE9BQU8sQ0FDTCxZQUFZLENBQUMsVUFBVSxDQUFDLFFBQVEsQ0FBQztZQUNqQyxRQUFRLENBQUMsS0FBSyxDQUFDLE1BQU07Z0JBQ25CLGlFQUFpRSxDQUNwRSxDQUFDO0lBQ0osQ0FBQztDQUNGIn0=